module.exports = __webpack_public_path__ + "images/emoji/vhs.e0c6c9277e5dbcef1836.png";